import commonDataAccess from "../commonDataAccess";
import { IListType } from "src/@redux/store";

export interface Category {
  id: number | string;
  category: string;
}

export interface CategoryListItem {
  id: number | string;
  name: string;
  organizationId: number;
}

class CategoryDataAccess {
  getAllCategory = (): Promise<Category[]> => {
    return commonDataAccess.getData("Category/getAll");
  };

  getCategoryList = (params: IListType): Promise<{ data: CategoryListItem[]; dataCount: number }> => {
    let _filters: Record<string, string> = {};
    params.filters?.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return commonDataAccess.getData("category/getall", parameters);
  };

  getCategoryInfo = (categoryId: number | string): Promise<{ success: boolean; data: Category }> => {
    return commonDataAccess.getData(`category/get/categoryInfo/${categoryId}`);
  };

  saveCategoryInfo = (payload: Partial<Category>): Promise<{ success: boolean; data: Category }> => {
    return commonDataAccess.postData("category/save", payload);
  };

  deleteCategoryInfo = (categoryId: number | string): Promise<{ success: boolean; message: string }> => {
    return commonDataAccess
      .deleteData("category/delete", { id: categoryId })
      .then((res) => ({
        success: res?.success,
        message: res?.message,
      }));
  };

  getAllCategoryForDropdown = (): Promise<Category[]> => {
    return commonDataAccess.getData("Category/dropdown");
  };

  deleteCategoriesBulk = (categoryIds: (number | string)[]): Promise<{ success: boolean; message: string; failedIds?: (number | string)[] }> => {
    return commonDataAccess.postData("category/deleteAll", categoryIds);
  };
}

export default new CategoryDataAccess();